import { render, staticRenderFns } from "./PublicNewsScreen.vue?vue&type=template&id=c08601b6&"
import script from "./PublicNewsScreen.vue?vue&type=script&lang=js&"
export * from "./PublicNewsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports